module.exports = __webpack_public_path__ + "img/per.fba4aeee.png";